<div class="content-block">
    <div class="dx-card responsive-paddings">

        <h2 class="content-block">Transactions</h2>
        <div class="content-block">
            <div class="dx-card responsive-paddings">Put your content here</div>
        </div>

    <div>
</div>
